import { observer } from 'mobx-react';
import { Flex } from '../UI/Flex/Flex';
import * as style from './Panel.module.less';
import classNames from 'classnames';

interface PanelProps {
    children?: React.ReactNode;
    className?: string;
    shadow?: boolean;
    fillCell?: boolean;
    title?: string;
    style?: React.CSSProperties;
}

export const Panel = observer((props: PanelProps) => {
    const className = props.className || '';
    const cls = classNames(
        style.panel,
        { [style.panel_shadow]: props.shadow },
        className,
        { [style.fillCell]: props.fillCell == true }
    );

    return (
        <Flex className={cls} direction="column" style={props.style}>
            {props.title && (
                <div className={style.panel_title}>{props.title}</div>
            )}
            {props.children}
        </Flex>
    );
});
